import React, { useState, useEffect } from "react";
import { Box, IconButton, Typography, Badge, Menu, MenuItem ,useMediaQuery} from "@mui/material";
import InputBase from "@mui/material/InputBase";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
const Topbar = () => {
    const [userName, setUserName] = useState("");
    const [currentTime, setCurrentTime] = useState(new Date());
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        // Fetch user name from local storage
        const name = localStorage.getItem("user_name");
        if (name) {
            setUserName(name);
        }

        // Update time every second
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        // Fetch notifications
        fetchNotifications();

        return () => clearInterval(timer);
    }, []);

    const fetchNotifications = async () => {
        // Replace with your actual API endpoint
        // const response = await fetch("https://api.example.com/notifications");
        // const data = await response.json();
        // setNotifications(data);
        // setUnreadCount(data.filter((notification) => !notification.read).length);
    };

    const markAsRead = (id) => {
        const updatedNotifications = notifications.map((notification) =>
            notification.id === id ? { ...notification, read: true } : notification
        );
        setNotifications(updatedNotifications);
        setUnreadCount(updatedNotifications.filter((notification) => !notification.read).length);
    };

    const handleNotificationClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const getGreeting = () => {
        const hour = currentTime.getHours();
        if (hour < 12) {
            return "Good Morning";
        } else if (hour < 18) {
            return "Good Afternoon";
        } else {
            return "Good Evening";
        }
    };

    const formatTime = (date) => {
        return date.toLocaleTimeString();
    };

    const formatDate = (date) => {
        return date.toLocaleDateString();
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        
        <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            justifyContent="space-between"
            alignItems={isMobile ? "stretch" : "center"}
             sx={{
    padding: {
      xs: '10px', 
      md: 3       
    }
  }}
            gap={isMobile ? 2 : 0}
        >
            {/* SEARCH BAR */}
            <Box
                display="flex"
                backgroundColor="#ffffff"
                borderRadius="3px"
                width={isMobile ? "100%" : "auto"}
            >
                <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
                <IconButton type="button" sx={{ p: 1 }}>
                    <SearchIcon />
                </IconButton>
            </Box>

            {/* GREETING, TIME, AND ICONS */}
            <Box
                display="flex"
                flexDirection={isMobile ? "column" : "row"}
                alignItems="center"
                justifyContent={isMobile ? "flex-start" : "center"}
                gap={isMobile ? 1 : 2}
            >
                <Typography variant="h6">
                    {`${getGreeting()}, ${userName}`}
                </Typography>
                <Typography variant="h6">
                    {`${formatTime(currentTime)} - ${formatDate(currentTime)}`}
                </Typography>
               <Box>
                 <IconButton onClick={handleNotificationClick}>
                    <Badge badgeContent={unreadCount} color="error">
                        <NotificationsOutlinedIcon />
                    </Badge>
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    {notifications.map((notification) => (
                        <MenuItem
                            key={notification.id}
                            onClick={() => markAsRead(notification.id)}
                        >
                            {notification.message}
                            {!notification.read && <span> (New)</span>}
                        </MenuItem>
                    ))}
                </Menu>
                <IconButton>
                    <SettingsOutlinedIcon />
                </IconButton>
                <IconButton>
                    <PersonOutlinedIcon />
                </IconButton>
               </Box>
            </Box>
        </Box>
    );
};

export default Topbar;